import { render } from "./AppNavigation.vue?vue&type=template&id=6a895552&scoped=true"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"

import "./AppNavigation.vue?vue&type=style&index=0&id=6a895552&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a895552"]])

export default __exports__